// @ts-ignore
import Video from './web/Video';
export default Video;
